// extracted by mini-css-extract-plugin
export default {"pageWithHeader":"Tab_pageWithHeader__PF+x-","ant-wave":"Tab_ant-wave__cUzuf","tab":"Tab_tab__kvnIj","active":"Tab_active__qA6Rt"};